import { render } from "./ChatController.vue?vue&type=template&id=3faffc80&scoped=true"
import script from "./ChatController.vue?vue&type=script&lang=js"
export * from "./ChatController.vue?vue&type=script&lang=js"

import "./ChatController.vue?vue&type=style&index=0&id=3faffc80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3faffc80"]])

export default __exports__